"use client";

import { memo } from "react";
import DatePicker from "@/components/DatePicker";
import type { DateRange } from "react-day-picker";

type SearchDateFieldProps = {
  isSingleDate: boolean;
  singleDate?: Date;
  rangeValue?: DateRange;
  isDatePickerOpen: boolean;
  useInlineFieldExpansion: boolean;
  inlineExpanded: boolean;
  onChangeSingle: (date: Date | undefined) => void;
  onChangeRange: (range: DateRange | undefined) => void;
  onOpenChange: (open: boolean) => void;
  onInlineExpandedChange?: (open: boolean) => void;
};

const SearchDateField = ({
  isSingleDate,
  singleDate,
  rangeValue,
  isDatePickerOpen,
  useInlineFieldExpansion,
  inlineExpanded,
  onChangeSingle,
  onChangeRange,
  onOpenChange,
  onInlineExpandedChange,
}: SearchDateFieldProps) => {
  return (
    <div className="flex-1 min-w-0">
      {isSingleDate ? (
        <DatePicker
          mode="single"
          ariaLabel="Select date"
          emptyLabel="Select date"
          value={singleDate}
          onChange={onChangeSingle}
          open={useInlineFieldExpansion ? undefined : isDatePickerOpen}
          onOpenChange={useInlineFieldExpansion ? undefined : onOpenChange}
          inlineExpanded={inlineExpanded}
          onInlineExpandedChange={onInlineExpandedChange}
        />
      ) : (
        <DatePicker
          mode="range"
          ariaLabel="Select date range"
          emptyLabel="Select dates"
          value={rangeValue}
          onChange={onChangeRange}
          open={useInlineFieldExpansion ? undefined : isDatePickerOpen}
          onOpenChange={useInlineFieldExpansion ? undefined : onOpenChange}
          inlineExpanded={inlineExpanded}
          onInlineExpandedChange={onInlineExpandedChange}
        />
      )}
    </div>
  );
};

export default memo(SearchDateField);
